// ──────────────────────────────────────────────
// Estados canónicos de edificios — fuente única de verdad
// ──────────────────────────────────────────────
// Los 7 estados válidos. Espeja el CHECK constraint `edificios_estado_check`
// (migración 20260620_edificios_estado_check_fase2.sql): para filas vivas
// (eliminada=false) el dominio de `estado` está garantizado a nivel DB.
//
// IMPORTANTE (FASE 3): este helper SOLO se crea + documenta. NO está cableado a
// los ~14 consumidores que hoy filtran estado por whitelist propia. Migrarlos es
// trabajo posterior (ver "Mapeo a consumidores" al final).

export const ESTADOS_EDIFICIO = {
  PROYECTO: "PROYECTO",
  PILOTO: "PILOTO",
  INSTALACION: "INSTALACIÓN",
  OPERATIVO: "OPERATIVO",
  STANDBY: "STANDBY",
  REACTIVACION: "REACTIVACIÓN",
  CADUCADO: "CADUCADO",
};

export const ESTADOS_EDIFICIO_LISTA = Object.values(ESTADOS_EDIFICIO);

// ── Conjuntos por fase de negocio ──
// Se exportan los arrays además de los predicados: los consumidores con query
// Supabase (`.in("estado", [...])`) necesitan el array; los filtros JS, el predicado.

// Cotizable: vendible hoy en cotizador / inventario comercial.
export const ESTADOS_COTIZABLE = ["INSTALACIÓN", "REACTIVACIÓN", "OPERATIVO"];

// Instalando: cotizable pero todavía sin operar (cotizable menos OPERATIVO).
export const ESTADOS_INSTALANDO = ["INSTALACIÓN", "REACTIVACIÓN"];

// Genera comisión de edificio: solo mientras opera.
export const ESTADOS_GENERA_COMISION = ["OPERATIVO"];

// Acepta CapEx / inversión: desde que hay proyecto hasta operación.
export const ESTADOS_ACEPTA_CAPEX = ["PROYECTO", "PILOTO", "INSTALACIÓN", "REACTIVACIÓN", "OPERATIVO"];

// Pre-cotizable: pipeline / dormido, todavía no vendible.
export const ESTADOS_PRE_COTIZABLE = ["PROYECTO", "PILOTO", "STANDBY"];

// Baja: fuera de operación de forma definitiva.
export const ESTADOS_BAJA = ["CADUCADO"];

// ── Predicados (reciben el string de estado) ──

export const esCotizable = (estado) => ESTADOS_COTIZABLE.includes(estado);
export const esInstalando = (estado) => ESTADOS_INSTALANDO.includes(estado);
export const generaComision = (estado) => ESTADOS_GENERA_COMISION.includes(estado);
export const aceptaCapex = (estado) => ESTADOS_ACEPTA_CAPEX.includes(estado);
export const esPreCotizable = (estado) => ESTADOS_PRE_COTIZABLE.includes(estado);
export const esBaja = (estado) => ESTADOS_BAJA.includes(estado);

// ──────────────────────────────────────────────
// Mapeo a consumidores actuales (referencia para migración futura — NO cableado aún)
// ──────────────────────────────────────────────
// esCotizable      → getEdificiosListadoPublico, FichaEdificios, useEdificiosData
//                    (rama includeInstallingBuildings), CotizadorProgrammaticInventario
//                    (rama allowedStates), CotizadorProgrammaticEditar.
//                    Hoy esos puntos usan whitelists que mezclan OPERATIVO/INSTALACIÓN/
//                    REACTIVACIÓN; REACTIVACIÓN no tiene filas en DB pero es canónico.
// generaComision   → getEdificiosOperativos, getSaldoEdificio, CalculadorComisionEdificio,
//                    useUnitEconomics, PdfCotizacion, LandingPeruNew, InventarioSimple
//                    (todos filtran estado === "OPERATIVO").
// aceptaCapex      → flujo de inversión/CapEx (activos destino_tipo='edificio') — hoy sin
//                    filtro de estado explícito; este predicado define la regla esperada.
// esPreCotizable   → vistas de pipeline / Mapa (estados PROYECTO/STANDBY visibles, no vendibles).
// esBaja           → CADUCADO; hoy excluido implícitamente por las whitelists de cotizable.
//
// Nota: el filtro de "vivo" (eliminada=false) es ortogonal a estos predicados y debe
// aplicarse además de ellos cuando se migren los consumidores.
